import { PageLayout } from "../components/PageLayout";
import { useDocumentMeta, navigate, ROUTES } from "../lib/router";

export function AboutPage() {
  useDocumentMeta({
    title: "このサイトについて | 食べログ ラーメン百名店マップ",
    description:
      "食べログ『ラーメン百名店』選出店舗を Google Maps 上で一覧・検索できる非公式インタラクティブマップです。全国の百名店を年度・エリア・選出回数で絞り込み、Google の評価・写真・営業時間までひと目で確認できます。",
  });

  return (
    <PageLayout title="このサイトについて" lastUpdated="2026-04-13">
      <p>
        <strong>食べログ ラーメン百名店マップ</strong>{" "}
        は、食べログ株式会社が選出・公開している「ラーメン百名店」の歴代選出店舗を
        Google Maps 上で一覧・検索できる非公式インタラクティブマップです。
      </p>

      <h2>このサイトで出来ること</h2>
      <ul>
        <li>全国のラーメン百名店 (TOKYO / 神奈川 / 北海道 / 愛知 / 大阪 / 東日本 / 西日本) をマップ上に一括表示</li>
        <li>エリア / 選出年 / 選出回数 (1〜9 回) / 店名ワードでの絞り込み検索</li>
        <li>閉店・移転・リニューアル店舗の別色表示と、移転先への遷移ボタン</li>
        <li>Google の評価・写真・営業時間・所在地・電話番号の表示</li>
        <li>店舗タップ時の自動ズームイン / バックナンバー一覧</li>
      </ul>

      <h2>データソース</h2>
      <p>
        店舗情報 (店名・選出年・エリア・都道府県・食べログ店舗 URL) は、運営者が
        食べログ公開ページの内容を手動で収集・整備したデータセットを使用しています。
        座標・住所・評価・営業時間・写真などは Google Maps Platform (Places API New)
        から取得しています。
      </p>
      <p>
        食べログからのデータ取得は規約上スクレイピングが禁止されているため、
        当サイトのアプリケーションコードが食べログに自動アクセスすることは
        一切ありません。
      </p>

      <h2>お問い合わせ</h2>
      <p>
        データの誤り、店舗情報の更新、機能の要望などがあれば、以下の連絡先まで
        お気軽にご連絡ください (運営者個人の管理のため、返信までお時間を
        いただく場合があります)。
      </p>
      <ul>
        <li>
          メール:{" "}
          <a
            href="mailto:contact@hyakumeiten-ramen-map.com"
            className="text-sky-400 underline underline-offset-2 hover:text-sky-300"
          >
            contact@hyakumeiten-ramen-map.com
          </a>
        </li>
        <li>
          X (旧 Twitter):{" "}
          <a
            href="https://x.com/kouhei_engineer"
            target="_blank"
            rel="noreferrer noopener"
            className="text-sky-400 underline underline-offset-2 hover:text-sky-300"
          >
            @kouhei_engineer
          </a>
        </li>
      </ul>

      <h2>関連ページ</h2>
      <ul>
        <li>
          <button
            type="button"
            onClick={() => navigate(ROUTES.privacy)}
            className="text-sky-400 underline underline-offset-2 hover:text-sky-300"
          >
            プライバシーポリシー
          </button>
        </li>
        <li>
          <button
            type="button"
            onClick={() => navigate(ROUTES.terms)}
            className="text-sky-400 underline underline-offset-2 hover:text-sky-300"
          >
            利用規約
          </button>
        </li>
        <li>
          <button
            type="button"
            onClick={() => navigate(ROUTES.disclaimer)}
            className="text-sky-400 underline underline-offset-2 hover:text-sky-300"
          >
            免責事項
          </button>
        </li>
      </ul>
    </PageLayout>
  );
}
